import "core-js/modules/es6.regexp.to-string";
import "core-js/modules/es6.date.to-string";
import "core-js/modules/es6.object.to-string";
var IDX = 36,
    HEX = '';

while (IDX--) {
  HEX += IDX.toString(36);
}

export default function (len) {
  var str = '',
      num = len || 11;

  while (num--) {
    str += HEX[Math.random() * 36 | 0];
  }

  return str;
}